import LogoCasa from '../img/logotipo-casa.png';
import LogoPontoCerto from '../img/logo-pontocerto.png';
import LogoViaMais from '../img/logo-viamais.png';
import LogoCompsoft from '../img/logo-compsoft.jpg';

export const empresas = {
  casa: {
    id: 'casa',
    nome: 'Casa Imob',
    cnpj: '46.972.550/0001-73',
    apiUrl: 'https://v1-csapi.compsoft.com.br:829',
    logo: {
      href: "https://casaimob.com.br/",
      src: LogoCasa,
      alt: "Logo Casa Imob",
      height: 60
    },
    favicon: {
      ico: '/favicon-casa.ico',
      png: '/favicon-casa.png',
    },
    cores: {
      primary: 'rgb(13, 73, 37)',
      primaryHover: 'rgb(10, 60, 30)',
      secondary: 'rgb(255, 73, 37)',
      secondaryHover: 'rgb(230, 60, 30)'
    }
  },
  pontocerto: {
    id: 'pontocerto',
    nome: 'Imobiliária Ponto Certo',
    cnpj: '11.095.665/0001-42',
    apiUrl: '/api',
    logo: {
      href: "https://www.imobiliariapontocerto.com.br/",
      src: LogoPontoCerto,
      alt: "Logo Ponto Certo",
      height: 200
    },
    favicon: {
      ico: '/favicon-pontocerto.ico',
      png: '/favicon-pontocerto.png',
    },
    cores: {
      primary: 'rgb(25, 118, 210)',
      primaryHover: 'rgb(21, 101, 192)',
      secondary: 'rgb(220, 0, 78)',
      secondaryHover: 'rgb(180, 0, 60)'
    }
  },
  viamais: {
    id: 'viamais',
    nome: 'Imobiliária Via Mais',
    cnpj: '08.836.227/0001-83',
    apiUrl: 'https://v1-csapi.compsoft.com.br:829',
    logo: {
      href: "https://www.imobiliariaviamais.com.br/",
      src: LogoViaMais,
      alt: "Logo Via Mais",
      height: 200
    },
    favicon: {
      ico: '/favicon-viamais.ico',
      png: '/favicon-viamais.png',
    },
    cores: {
      primary: 'rgb(50, 58, 95)',
      primaryHover: 'rgb(50, 58, 192)',
      secondary: 'rgb(71, 89, 148)',
      secondaryHover: 'rgb(71, 89, 150)'
    }
  },
  compsoft: {
    id: 'compsoft',
    nome: 'Compsoft',
    cnpj: '',
    apiUrl: 'https://v1-csapi.compsoft.com.br:829',
    logo: {
      href: "https://www.compsoft.com.br/",
      src: LogoCompsoft,
      alt: "Logo Compsoft",
      height: 60
    },
    favicon: {
      ico: '/favicon-compsoft.ico',
      png: '/favicon-compsoft.png',
    },
    cores: {
      primary: 'rgb(240, 125, 0)',
      primaryHover: 'rgb(210, 109, 0)',
      secondary: 'rgb(60, 60, 60)',
      secondaryHover: 'rgb(45, 45, 45)'
    }
  }
};